import React from "react";

const industries = [
  { icon: "🛍️", title: "Retail & Fashion" },
  { icon: "🧠", title: "Tech Startups" },
  { icon: "🏢", title: "Real Estate" },
  { icon: "🏥", title: "Healthcare" },
  { icon: "🏛️", title: "Agencies & Enterprises" }
];

const Section5 = () => {
  return (
    <div className="w-full bg-gray-100 py-[10px] md:py-[10px]">
      <div className="w-[90%] md:w-[85%] mx-auto text-center">
        <h2
          className="text-center leading-[29px] md:leading-[41px] text-[24px] md:text-[30px] text-[#151515] font-bold mb-10"
        >          Industries We Work With in New York
        </h2>

        <p className="text-[15px] md:text-[18px] text-[#444444] leading-[24px] mb-10 max-w-[600px] mx-auto">
          We deliver custom UI, automation tools, online stores, and client portals tailored for your sector's specific needs.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-6">
          {industries.map((industry, index) => (
            <div key={index} className="bg-white p-6 rounded-lg shadow-sm hover:shadow-md transition-all duration-300 hover:scale-105">
              <div className="text-4xl mb-4">{industry.icon}</div>
              <h3 className="text-[16px] md:text-[18px] font-semibold text-[#DA2128] leading-[20px]">
                {industry.title}
              </h3>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Section5;
